export default __webpack_public_path__ + "static/client-5a5f7bcc7030bd90b5560b1bd4d7e92c.png";